module.exports = __webpack_public_path__ + "static/media/fruit_sorting.b7c9fdf3.jpeg";